import type { FlagConfiguration } from '@atlassian/jira-flags';

import messages from './messages';

const UndoSuccessFlag: FlagConfiguration = {
	title: messages.title,
	type: 'success',
	isAutoDismiss: true,
};

export default UndoSuccessFlag;
